import { Component , Output ,HostListener} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material';
import { Api,ApplicationVariables} from '../../providers/api';
// import { FileDropModule, UploadFile, UploadEvent } from 'ngx-file-drop/lib/ngx-drop';
import {Subscription} from 'rxjs';
import { Http,RequestOptions ,Headers } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { APPCONFIG } from '../../config';
import {ConfirmDeleteLocationDialogComponent} from './confirm-deleteLocation-dialog.component'
import {ConfirmDeleteDialogComponent} from "./ConfirmDeleteDialogComponent";
import {ConfirmCreateCustomerWithExistingNameComponent} from "./ConfirmCreateCustomerWithExistingNameComponent";


// openDialogWithAResult
@Component({
  selector: 'customers-dialog',
  template: require('./customers-dialog.component.html')

})
export class CustomersDialogComponent {

  busy: Subscription;
  imageURL = "";
  imagesBaseUrl = "";
  customer:any = {};
  taxGroup: any =[];
  customerGroup: any = [];
  termCode: any = [];
  currencies: any = [];
  paymentProcessingCode: any = [];
  discountTagsList: any = [];
  saleRepCodes:any = [];
  countories: any = [];
  provinces = [];
  shippingService = [];
  isShippingAdding: any = false;
  shippingArray: any = [];
  shippingServiceName: any;
  shippingServiceId: any;
  adpcustomersId;
  mask;
  maskLength:Number;
  customerCountryCode:String="";
  // receiverCountryCode:String="";
  countryCodeMask;
  enableEditlocation:boolean=true
  enableAddlocation:boolean=true;
  enablePrimaryLocation:boolean=true;
  supplierPaymentStatus = false;



  isEditingSingleShippingService:any = true;


  customerBackUp : any = {};
  customerBackUpMaster = {};
  selectedLocation:any = {};
  public checkboxPrimary: boolean=true;
  customerAlreadyExist = false;




  constructor(public dialogRef: MatDialogRef<CustomersDialogComponent>,private api:Api,private matDialog:MatDialog) {
    setTimeout(() => {
      this.getTaxGroup();
    }, 5);
  setTimeout(() => {
    this.getTermCode();
  }, 10);

    setTimeout(() => {
      this.getPaymentProcessing();
    }, 20);

  setTimeout(() => {
    this.getCountories();
  }, 60);

    setTimeout(() => {
      this.getCustomerGroup();
    }, 20);
    
    setTimeout(() => {
      this.getSaleRepCode();
    }, 35);

    setTimeout(() => {
      this.getShippingServive();
    }, 30);


    setTimeout(() => {
      this.getCurrenciesList();
    }, 30);

    setTimeout(() => {

      // console.log("beforxxxxxxxxxxxxxxxxxxxxxe condiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiition",this.customer.Locations[0].state);
      if(ApplicationVariables.currentCustomer.Locations !== undefined && this.customer.Locations.length > 0 && this.customer.Locations[0].country !== undefined && this.customer.Locations[0].country !== "") {
        this.getProvincesWhileEditing(this.customer.Locations[0].country)
      }
    }, 30);



    this.setMask();
    let paymentStatus = localStorage.getItem("supplierPayment")
    // alert("FFFFFFFFFF" + paymentStatus)
    if(paymentStatus !== null && paymentStatus == '1'){
        this.supplierPaymentStatus = true;
    }
    this.adpcustomersId = api.getUser().adpcustomersId;
    this.countryCodeMask= this.api.countryCodeMask
    // this.mask = this.api.PHONE_MASK;
    //this.dialogRef.disableClose = true;
    this.imagesBaseUrl = APPCONFIG.imagesBaseUrl;
    this.customer = ApplicationVariables.currentCustomer;


    this.customerBackUpMaster = JSON.parse(JSON.stringify(this.customer));
    this.imageURL = "";
    // if(!(this.customer.customerPhone==null || this.customer.customerPhone==undefined || !this.customer.isEditFlag)) {
    //   console.log("before split", this.customer.customerPhone)
    //   this.customer.customerPhone = this.splitPhoneNumber(this.customer.customerPhone, true);
    // }
    if(this.customer.isEditFlag){   //          this is for  disabling editing primiary location
      this.enablePrimaryLocation=false;      // this will be set to true when already primary location is unmarked AS PRIMARY
    }
      console.log(this.customer);

    if(this.customer.shippingService !== undefined)
    setTimeout(() => {
      // this.customer.shippingService = [];
      console.log("this.customer.shippingService ---- ", this.customer.shippingService);
      
        this.shippingArray = this.customer.shippingService;
      this.customer.shippingServiceDTOs = this.customer.shippingService;
        console.log("this.shippingArray", this.shippingArray);
    if(this.customer.shippingService.length>0)
    for(let i of this.shippingArray){
      i.isShippingAdding = false;
      i.isEditingSingleShippingService = false;
    }
    console.log("this.shippingArray constructor", this.shippingArray);
    }, 500);


    this.getDiscounts();

  
  }

imageNotFound(e,item){
   // this.imageURL = this.imagesBaseUrl+"products/400x400/nan-400x400.jpg"
  }

  setMask(){
    if (localStorage.getItem('countryCode').length == 2) {
      this.mask = ['+',/\d/,' ','(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    } else if (localStorage.getItem('countryCode').length == 3) {
      this.mask = ['+',/\d/,/\d/,' ','(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    } else {
      this.mask = ['+',/\d/,' ','(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }
    this.maskLength=this.mask.length;
    console.log("mask.length",this.mask,this.maskLength)

  }

  getShowStatus(tax){
    if(tax.code === "pre-order" && this.supplierPaymentStatus === false){
      return false;

    }else {
      return true;
    }
  }

  getRandomId(){
    return -Math.floor(Math.random() * 1000) + 1
  }


  getImageURL(){

    return  "";

    // return APPCONFIG.imagesBaseUrl +
    // "/" + this.api.getADPCustomerUUID() +
    // "/products/400x400/" + this.product.imageName + "-400x400."+
    // this.product.imageExtension;
  }
  // splitPhoneNumber(phoneNumber:String,phonebearer:boolean){
  //   if(phoneNumber[0]=="+") {
  //     let phoneCut = phoneNumber.split("(", 2)
  //     phoneNumber = "(" + phoneCut[1];
  //     if(phonebearer===true)
  //       this.customerCountryCode = phoneCut[0];
  //     else if(phonebearer===false)
  //             this.receiverCountryCode=phoneCut[0]
  //    }
  //   return phoneNumber;
  // }

  // splitPhone(phoneNumber:String,phonebearer:boolean){
  //   phoneNumber
  // }

  toggleEditAddress(location){
    this.enableAddlocation=false;
    this.enableEditlocation=false;
  // console.log("before,This location flags, E,A:",location.isEditFlag,location.isAddFlag);
    for(let loc of this.customer.Locations){
      loc.isEditFlag = false;
    }
    // console.log("first,This location flags, E,A:",location.isEditFlag,location.isAddFlag);

    // console.log("edit location called");
    this.selectedLocation = JSON.parse(JSON.stringify(this.customer.Locations));
    console.log(this.selectedLocation);
    location.isEditFlag = !location.isEditFlag;
    console.log("phone before split in edit location",location.isEditFlag)
    // if(!(location.phone==null || location.phone==undefined || location.phone=="")) {
    //   console.log("inside split condition at edit button",location.phone)
    //   location.phone = this.splitPhoneNumber(location.phone, false)
    //   console.log("inside split condition after split",location.phone)
    //
    // }
    // console.log("second,This location flags, E,A:",location.isEditFlag,location.isAddFlag);

    this.getProvincesWhileEditing(location.country);
  }
  deleteThisLocation(location,index:number,createFlag:boolean){
    if(location.isShipToAddress==1){
      this.api.toastMsg("Primary Location cannot be Deleted", "");
    }else {
      console.log("Customer creation Flag", createFlag);
      const dialogRef = this.matDialog.open(ConfirmDeleteLocationDialogComponent, {disableClose: true,});
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'confirm') {
          if (!createFlag) {
            this.api.delete("customer/deleteLocation/" + location.id).subscribe((response) => {
                  console.log("response", response.json());
                  let res = response.json();
                  if (res.status == '200') {
                    this.deleteLocation(location, index);
                    this.api.toastMsg("Location deleted successfully", "");
                  }
                },
                (error) => {
                  this.api.toastMsg("Something Went Wrong", "");
                })
          } else if (createFlag)
            this.deleteLocation(location, index);
        } else if (result === 'cancel') {
          console.log("cacnel delete location")
        }
      });
    }

  }
  deleteLocation(location,index){
    console.log("location to delete","index",location,index);
    if(this.customer.Locations[index]["isShipToAddress"] == 1){
        this.enablePrimaryLocation=true;
    }
    this.customer.Locations.splice(index, 1);
    console.log("all location",this.customer.Locations);
  }

  checkPrimary(location,index){
      console.log("check",this.customer.Locations[index]["isShipToAddress"]);
    if(location.locationType == "BILLTO"){
      setTimeout(()=>{
        this.customer.Locations[index]["isShipToAddress"] = 0;
      })
      this.api.toastMsg("“Bill To” location type cannot be selected as “Primary”","");
    }
    else if(!this.customer.Locations[index]["isShipToAddress"]){
      this.customer.Locations[index]["isShipToAddress"]=true;
    }
    else {
      for (let loc of this.customer.Locations) {
        loc.isShipToAddress = 0
      }
      this.customer.Locations[index]["isShipToAddress"] = 1;
    }

    console.log("All locaitons in creating Customer",this.customer.Locations);
  }
  changePrimary(location,index){
    console.log("check",this.customer.Locations[index]["isShipToAddress"]);
    if(location.locationType == "BILLTO"){
      setTimeout(()=>{
        this.customer.Locations[index]["isShipToAddress"] = 0;  //BILLTO location cannot be marked Primary
      })
      this.api.toastMsg("“Bill To” location type cannot be selected as “Primary”","");
    }
    else if(!this.customer.Locations[index]["isShipToAddress"]){
      this.customer.Locations[index]["isShipToAddress"]=true
    }
    else {
      for (let loc of this.customer.Locations){
        loc.isShipToAddress=0
      }
      this.customer.Locations[index]["isShipToAddress"]=1
    }

    console.log("All locaitons in editing Customer",this.customer.Locations);
  }

  undoChanges(location){
    console.log("Undo Changes");

    location.isEditFlag = false;
    this.customer.Locations = JSON.parse(JSON.stringify(this.selectedLocation));
    this.selectedLocation = {};
    console.log(location);
    // this.receiverCountryCode="";
    this.enableAddlocation=true;
    this.enableEditlocation=true;
  }

  update(location){

    console.log("llllllllllllllllllllllllll" + location.state)

    if (!location.locationType || location.locationType == "") {
      this.api.toastMsg("Location Type is required to add a location","");
    } else if(location.receiverName=="" || location.receiverName==undefined){
      this.api.toastMsg("Contact Person is required to add a location","")
    }  else if(location.addressLine1=="" || location.addressLine1==undefined){
      this.api.toastMsg("Address Line 1 is required to add a location","")
    }else if(location.city=="" || location.city==undefined ){
      this.api.toastMsg("City is required to add a location","")
    }else if(location.state == ""|| location.state == undefined ){
      this.api.toastMsg("State/Province is required to add a location","")
    }
    else if(location.country=="" || location.country==undefined ){
      this.api.toastMsg("Country is required to add a location","")  // made cumpolsary on June 19,2019 after NH approval
    }
    else if(location.zipCode=="" || location.zipCode==undefined ){
      this.api.toastMsg("Zip/Postal Code is required to add a location","")  // made cumpolsary on June 19,2019 after NH approval
    }
    else if(location.email=="" || location.email==undefined ){
      this.api.toastMsg("Receiver Email is required to add a location","")  // made cumpolsary on June 19,2019 after NH approval
    }
    else if(!this.validateEmail(location.email) ){
      this.api.toastMsg("Receiver Email is not valid","");
      return false;
    }else {
      console.log("update called");
      this.selectedLocation ={};
      location.isEditFlag = false;
      if(location.locationType=="BILLTO" && location.isShipToAddress==1)
        location.isShipToAddress=0;
      // if(!(location.phone==undefined || location.phone.trim()=="" || location.phone==null))
      //   location.phone=this.receiverCountryCode+' '+ location.phone;
      // this.receiverCountryCode="";
      this.enableAddlocation=true;
      this.enableEditlocation=true;
    }




    // console.log("update called");
    // this.selectedLocation ={};
    // location.isEditFlag = false;
    // if(location.locationType=="BILLTO" && location.isShipToAddress==1)
    //       location.isShipToAddress=0;
    // // if(!(location.phone==undefined || location.phone.trim()=="" || location.phone==null))
    // //   location.phone=this.receiverCountryCode+' '+ location.phone;
    // // this.receiverCountryCode="";
    // this.enableAddlocation=true;
    // this.enableEditlocation=true;
  }
  cancelNew(location){
    console.log("cancel add new location  callled");
    location.isEditFlag=false;
    this.customer.Locations.splice( this.customer.Locations.indexOf(location), 1 );
  }

  addLocationComplete(location,index){



    let billToLocationsCount = 0;

    if(location.locationType !== "" && location.locationType === "BILLTO"){
      for(let loc of this.customer.Locations){
        if(loc.locationType === "BILLTO"){
          billToLocationsCount++;
        }
      }

      if(billToLocationsCount > 1){
        this.api.toastMsg("You can't add more than 1 billto location","");
        return;
      }
    }




    console.log("llllllllllllllllllllllllll" + location.state)

    if (!location.locationType || location.locationType == "") {
       this.api.toastMsg("Location Type is required to add a location","");
    } else if(location.receiverName=="" || location.receiverName==undefined){
      this.api.toastMsg("Contact Person is required to add a location","")
    }  else if(location.addressLine1=="" || location.addressLine1==undefined){
      this.api.toastMsg("Address Line 1 is required to add a location","")
    }else if(location.city=="" || location.city==undefined ){
        this.api.toastMsg("City is required to add a location","")
    }
    else if(location.state == ""|| location.state == undefined ){
      this.api.toastMsg("State/Province is required to add a location","")
    }
    else if(location.country=="" || location.country==undefined ){
      this.api.toastMsg("Country is required to add a location","")  // made cumpolsary on June 19,2019 after NH approval
    }
    else if(location.zipCode=="" || location.zipCode==undefined ){
      this.api.toastMsg("Zip/Postal Code is required to add a location","")  // made cumpolsary on June 19,2019 after NH approval
    }
    else if(location.email=="" || location.email==undefined ){
      this.api.toastMsg("Receiver Email is required to add a location","")  // made cumpolsary on June 19,2019 after NH approval
    }
    else if(!this.validateEmail(location.email) ){
      this.api.toastMsg("Receiver Email is not valid","");
      return false;
    }else{
      console.log("this.customer",this.customer)
      this.selectedLocation ={};
      location.isEditFlag = false;
      location.isAddFlag = false;
      this.enableAddlocation=true;
      this.enableEditlocation=true;

      if(location.locationType=="BILLTO" && location.isShipToAddress == 1)
          location.isShipToAddress=0;
      // if(!(location.phone==undefined || location.phone.trim()=="" || location.phone==null || this.receiverCountryCode.trim()==""))
      //     location.phone=this.receiverCountryCode+' '+ location.phone;
      // this.receiverCountryCode="";
      location.customerId=this.customer.id;
      setTimeout(()=>{
        this.customerBackUpMaster = JSON.parse(JSON.stringify(this.customer));
      },50);
      
    }

  }


  addLocation(){
    this.customerBackUp = JSON.parse(JSON.stringify(this.customer));
    var alreadyOpendLocation = false;
    for(let loc of this.customer.Locations){
      if(loc.isAddFlag && loc.isEditFlag){
         this.api.showToastInfo("Click “Add” or “Update” to complete the Location section");
         this.api.toastMsg("Click “Add” or “Update” to complete the Location section","");
         this.customer = JSON.parse(JSON.stringify(this.customerBackUp));
         alreadyOpendLocation = true;
      }
      
    }
    if(!alreadyOpendLocation){
      // this.customer.Locations.push({id:0,isEditFlag:true,isAddFlag:true,isShipToAddress:0});
      this.customer.Locations.push({id:0,isEditFlag:true,isAddFlag:true,isShipToAddress:0,email:this.customer.email});
      // this.receiverCountryCode="";
      this.enableEditlocation=false;
      this.enableAddlocation=false;
    }  
  }

  cancelAdd(location){
    // this.customer = {};
    // setTimeout(()=>{
    //   this.customer = JSON.parse(JSON.stringify(this.customerBackUpMaster));
    // },50);
    this.checkEmptyLocation();
    // this.receiverCountryCode="";
    this.enableAddlocation=true;
    this.enableEditlocation=true;
  }

  setPhoneNumber(){
    // if(this.customerCountryCode==undefined || this.customerCountryCode.trim()=="" || this.customerCountryCode.substr(1)==""||this.customerCountryCode==null ){
    //   this.api.toastMsg("Please provide country code for Customer","");
    //   return false;
    //
    // }else
      if(this.customer.customerPhone == undefined ||this.customer.customerPhone == ""|| this.customer.customerPhone == null) {
              this.api.toastMsg("Phone is required","");
              return false
    }
    else{
      // console.log("before merge:", this.customer.customerPhone);
      // if (this.customer.customerPhone[0] !== '+') {
      //   this.customer.customerPhone = this.customerCountryCode + ' ' + this.customer.customerPhone;
      // }
    return true
    }

      }

  close(typ){
    console.log("TTTTT " + typ)
    if(typ == 'update'){

      if(this.validateCustomer()){

        this.dialogRef.close(typ);
      }else{

      }
    }else if(typ == 'create'){

      // alert("fdff " + this.customerAlreadyExist)

      if(this.validateCustomer()){

        if(this.customerAlreadyExist){
          const dialogRef = this.matDialog.open(ConfirmCreateCustomerWithExistingNameComponent);
          dialogRef.afterClosed().subscribe((result) => {
            if (result == 'confirm') {
              this.dialogRef.close(typ);
            }
          });
        }else {
          this.dialogRef.close(typ);
        }

      }else{

      }
    } else{
      console.log("No. of locations before:",this.customer.Locations.length)
    //this.customerBackUpMaster = JSON.parse(JSON.stringify(this.customer));
     this.checkEmptyLocation()
      console.log("No. of locations after:",this.customer.Locations.length)
      console.log("customer cancel on edit -- ", this.customer);
    console.log("customerBackUpMaster cancel on edit -- ", this.customerBackUpMaster);
      this.customer = this.customerBackUpMaster;
      this.dialogRef.close('cancel');
      this.customer.isCreateFlag = false;
      this.customer.isEditFlag = false;
    }
  }
checkEmptyLocation() {
  let primaryLoations: number = 0
  for (let loc of this.customer.Locations) {
    if (loc.isAddFlag && loc.isEditFlag) {
      this.customer.Locations.splice(this.customer.Locations.indexOf(loc), 1);
    }

  }

}

  isNoPrimaryLocation(){
    let primaryLoations: number = 0
    for (let loc of this.customer.Locations) {
      if(loc.isShipToAddress) loc.isShipToAddress = 1;
      if(!loc.isShipToAddress) loc.isShipToAddress = 0;
      if (loc.isShipToAddress == 1) {
        primaryLoations++;
      }
    }
    if(primaryLoations<1) {
      this.api.toastMsg("Select one “Primary” shipping location", "");
      return false
    }else return true
    }

  billToAddressCheck(){
    let bittoLocCount: number = 0
    for (let loc of this.customer.Locations) {
      if(loc.locationType === "BILLTOSHIPTO" || loc.locationType === "BILLTO"){
        bittoLocCount++;
      }

    }
    if(bittoLocCount<1) {
      this.api.toastMsg("Please add at least 1 Bill To location", "");
      return false
    }else return true
  }


  
  validateCustomer(){

    console.log(this.customer);
    console.log("location array length",this.customer.Locations.length);
    if(this.customer.Locations.length === 0){
      this.api.toastMsg("Add at least one location","");
      this.enableAddlocation=true;
      return false;
    }
    for (let loc of this.customer.Locations) {
      console.log("location number", loc.isEditFlag);
      if (loc.isAddFlag || loc.isEditFlag) {
        this.api.showToastInfo("Click “Add” or “Update” to complete the Location section");
        this.api.toastMsg("Click “Add” or “Update” to complete the Location section", "");
        return false;
      }
    }
    if(this.customer.customerName==undefined || this.customer.customerName.trim()=="" || this.customer.customerName==null ){
      this.api.toastMsg("Company Name is required","");
      return false;
    }
    else if(this.customer.contactPerson==undefined || this.customer.contactPerson.trim()=="" || this.customer.contactPerson==null){
      this.api.toastMsg("Contact Person is required","");
      return false;
    }

    else if(this.customer.email==undefined || this.customer.email.trim()=="" || this.customer.email==null){
      this.api.toastMsg("Email is required","");
      return false;
    }

    else if(!this.validateEmail(this.customer.email) ){
      this.api.toastMsg("Email is not valid","");
      return false;
    } else if(!this.setPhoneNumber()){
      //this.api.toastMsg("Customer Phone is not valid","");
      return false;
    }else if(!this.isNoPrimaryLocation()){
      return false
    }else if(!this.billToAddressCheck()){
      return false
    }else if(this.customer.paymentCurrency === undefined || this.customer.paymentCurrency === ""){
      this.api.toastMsg("Payment currency can't be empty","")
      return false
    }
    else{
           this.checkEmptyLocation();
        // if(
        //   this.customer.salePersonCode =="" ||
        //   this.customer.taxGroup == "" ||
        //   this.customer.customerCompany == "" ||
        //   this.customer.email == "" ||
        //   this.customer.groupCode ==""
        //    ){
        //    this.api.toastMsg("Some of the fields can't be empty","");
        //    return false;
        // }else{
        //   return true;
        // }
      return true;
      }

    }





  

  validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
  }


  getTaxGroup(){
    let query = " ";
    let offset = 0;
    let resultcount = 100
    this.api.get("lookups/search/"+query+"/"+offset+"/"+resultcount+"/taxGroup")
		.subscribe(data => {
				if(data.status == 401){
                    this.api.tokenExpiredLogout();
                  }else{
	      console.log(data.json().lookups);
				this.taxGroup = data.json().lookups;
			}
			},err=>{
				console.log("Error", err);
			});
  }

  getCustomerGroup(){
    let query = " ";
    let offset = 0;
    let resultcount = 100
    this.api.get("lookups/search/"+query+"/"+offset+"/"+resultcount+"/customerGroup")
		.subscribe(data => {
				if(data.status == 401){
                    this.api.tokenExpiredLogout();
                  }else{
	      
				this.customerGroup = data.json().lookups;
			}
			},err=>{
				console.log("Error", err);
			});
  }

  getTermCode(){
    let query = " ";
    let offset = 0;
    let resultcount = 100
    this.api.get("lookups/search/"+query+"/"+offset+"/"+resultcount+"/termsCode")
		.subscribe(data => {
				if(data.status == 401){
                    this.api.tokenExpiredLogout();
                  }else{
	      
				this.termCode = data.json().lookups;
			}
			},err=>{
				console.log("Error", err);
			});
  }

  getPaymentProcessing(){
    let query = " ";
    let offset = 0;
    let resultcount = 100
    this.api.get("lookups/searchWithOutAdpCustomerId/"+query+"/"+offset+"/"+resultcount+"/payment-processing")
        .subscribe(data => {
          if(data.status == 401){
            this.api.tokenExpiredLogout();
          }else{

            for(let pay of data.json().lookups){
              if(pay.code === "pre-order" && this.supplierPaymentStatus === false){
                // return false;

              }else {
                this.paymentProcessingCode.push(pay)
              }
            }

            // this.paymentProcessingCode = data.json().lookups;
          }
        },err=>{
          console.log("Error", err);
        });
  }

  // getCountories(){
  //   let query = " ";
  //   let offset = 0;
  //   let resultcount = 100
  //   this.api.get("lookups/search/"+query+"/"+offset+"/"+resultcount+"/country")
	// 	.subscribe(data => {
	// 			if(data.status == 401){
  //                   this.api.tokenExpiredLogout();
  //                 }else{
	// 			this.countories = data.json().lookups;
	// 		}
	// 		},err=>{
	// 			console.log("Error", err);
	// 		});
  // }

  getCountories(){
    this.api.getCountryListRA("/api/v1/codes/all/0").subscribe(result=>{
      this.countories=result.json().data;
      console.log("CountryCodes from RA Service", this.countories);
    },err=>{
      			console.log("Error", err);
      		});
  }

  getSaleRepCode(){
    console.log("sale rep function called")
    this.api.get("jusers/saleRepCode")
		.subscribe(data => {
				if(data.status == 401){
                    this.api.tokenExpiredLogout();
                  }else{
	      
        console.log("received sale rep codes:",data.json());
        this.saleRepCodes = data.json().saleRepCodes;

        for(let code of this.saleRepCodes){
          code.id = JSON.stringify(code.id);
        }
        console.log(this.saleRepCodes);
        
			}
			},err=>{
				console.log("Error", err);
			});
  }

  getShippingServive(){
    let query = " ";
    let offset = 0;
    let resultcount = 100
    this.api.get("lookups/search/"+query+"/"+offset+"/"+resultcount+"/shippingServices")
		.subscribe(data => {
				if(data.status == 401){
                    this.api.tokenExpiredLogout();
                  }else{
	      
				this.shippingService = data.json().lookups;
			}
			},err=>{
				console.log("Error", err);
			});
  }


  createShippingServiceArray(shipAr){
    if(shipAr.shippingServiceValue.trim() === ""){
      this.api.toastMsg("Please fill all fields", "");
    }else if(shipAr.shippingServiceId == 0){
      this.api.toastMsg("Please fill all fields", "");
    }
    else{
    shipAr.isShippingAdding = false;
    this.customer.shippingServiceDTOs = this.shippingArray;
    console.log("this.shippingArray", this.customer);
    this.isShippingAdding = false;
    this.isEditingSingleShippingService = true;
    }

  }


  cancelShippingServiceArray(shipAr){
    shipAr.isShippingAdding = false;
    this.shippingArray.splice(-1,1);
    this.isEditingSingleShippingService = true;

  }


  addObjectArr(){
    this.shippingArray.push({
      id: this.getRandomId(),
      customerId: this.customer.id,
      shippingServiceId: 0,
      shippingServiceValue: "",
      adpCustomerId: this.adpcustomersId+"",
      isShippingAdding: true
  });
  this.isEditingSingleShippingService = false
  }



getValueOfShippingService(){

}

getNameFromId(id){
  for(let i of this.shippingService){
    if(id == i.id){
      return i.description;
    }
  }
}


editingSingleShippingService(ship){
  ship.isEditingSingleShippingService = false;
  // this.isEditingSingleShippingService = true;
  this.customer.shippingServiceDTOs = this.shippingArray;
  console.log("this.customer.............",this.customer)
}

editingSingleShipping(ship){
  ship.isEditingSingleShippingService = true;
  // this.isEditingSingleShippingService = true;
}

removeshipingservice(obj){
  this.shippingArray = this.shippingArray.filter((o)=> o.id != obj.id);
  this.customer.shippingServiceDTOs = this.shippingArray;
  console.log("this.customer.............",this.customer)
}

  getDiscounts(){
    this.api.getRt("/discount/findAllDiscountsByAdpCustomerId")
        // this.api.getCatalyst("store/getActiveAdpCustomerStoresList" )
        .subscribe(data => {
          if (data.status == 401) {
            this.api.tokenExpiredLogout();
          } else {

            console.log("Data from rt : " + JSON.stringify(data));

            let data2 = data.json();
            // this.totalSearchCount = data2.searchCount;
            // this.totalPagesAvailable = Math.abs(this.totalSearchCount / resultcount);
            this.discountTagsList = data2.data;



          }
        }, err => {

        });
  }


  getProvinces(location,abbreviation,event){
    if (event.isUserInput){
      location.state = ""
      let query = " ";
      let offset = 0;
      let resultcount = 100
      this.api.get("lookups/searchWithOutAdpCustomerId/"+query+"/"+offset+"/"+resultcount+"/Province-"+abbreviation)
          .subscribe(data => {
            if(data.status == 401){
              this.api.tokenExpiredLogout();
            }else{

              this.provinces =  data.json().lookups

              // this.paymentProcessingCode = data.json().lookups;
            }
          },err=>{
            console.log("Error", err);
          });
    }

  }
  getProvincesWhileEditing(abbreviation){

      let query = " ";
      let offset = 0;
      let resultcount = 100
      this.api.get("lookups/searchWithOutAdpCustomerId/"+query+"/"+offset+"/"+resultcount+"/Province-"+abbreviation)
          .subscribe(data => {
            if(data.status == 401){
              this.api.tokenExpiredLogout();
            }else{
              this.provinces =  data.json().lookups
            }
          },err=>{
            console.log("Error", err);
          });

  }

  checkCustomerWithSameNameAlreadyExist(){
    this.api.getRt("/customers/getCustomerByCompany?company="+this.customer.customerName)
        .subscribe(data => {

          let jsonObj = data.json();
          // alert("dddd " + JSON.stringify(jsonObj))
          if (jsonObj.status === "200") {
            this.customerAlreadyExist = true;
          } else {
            this.customerAlreadyExist = false;

          }
        }, err => {

        });
  }


  getCurrenciesList(){
    let query = " ";
    let offset = 0;
    let resultcount = 100
    this.api.get("lookups/search/"+query+"/"+offset+"/"+resultcount+"/currency")
        .subscribe(data => {
          if(data.status == 401){
            this.api.tokenExpiredLogout();
          }else{

            this.currencies = data.json().lookups;
          }
        },err=>{
          console.log("Error", err);
        });
  }




}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/customers/home/customers-dialog.component.ts